import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface PositionGroup {
    groupName: string;
    positionIds: number[];
    displayName: string;
}

export interface PCDBSearchResult {
    partTerminologyId: number;
    partTerminologyName: string;
    categoryId: number;
    categoryName: string;
    subcategoryId: number;
    subcategoryName: string;
    positionGroups: PositionGroup[];
    allPositionIds: number[];
}

interface SearchPCDBResponse {
    results: PCDBSearchResult[];
}

const searchPCDB = async (query: string, sessionId: string): Promise<SearchPCDBResponse> => {
    const { data } = await axios.get(`${API_URL}/pcdb/search`, {
        params: { q: query },
        headers: {
            Authorization: sessionId
        }
    });
    return data;
};

export const useSearchPCDB = (query: string) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['pcdb', 'search', query],
        queryFn: () => searchPCDB(query, sessionContext?.sessionId ?? ''),
        enabled: !!sessionContext?.sessionId && query.trim().length >= 2,
    });
};
